import licenseModule from '../license.module';

export default licenseModule.factory(
    'licenseRegisterNewInstanceWorkflowService',
    licenseRegisterNewInstanceWorkflowService
);

function licenseRegisterNewInstanceWorkflowService($filter) {
    var navigationItems = require('./licenseRegisterNewInstanceWorkflowService.workflowitems');

    var nav = {
        options: {},
        items: navigationItems,
        step: 0,
        selected: navigationItems[0],
        selectedValue: function() {
            return this.selected.value;
        },
        isFirstStep: function() {
            return navigationItems[0] == this.selected;
        },
        isLastStep: function() {
            return navigationItems[navigationItems.length - 1] == this.selected;
        },
        isInProcess: function() {
            return !this.isFirstStep() && !this.isLastStep();
        },
        next: function() {
            this.step++;
            this.selected = navigationItems[this.step];
        },
        previous: function() {
            if (this.step > 0) {
                this.step--;
            }
            this.selected = navigationItems[this.step];
        }
    };

    function getNavigation() {
        return nav;
    }

    function selectNavigation(navigationValue) {
        var item = $filter('filter')(nav.items, { value: navigationValue })[0];
        nav.selected = item;
        nav.step = navigationItems.indexOf(item);
    }
    function resetNavigation() {
        selectNavigation('server');
    }

    function getCurrentNavigationValue() {
        return nav.selected.value;
    }

    // return the interface
    return {
        getWorkflow: getNavigation,
        selectWorkflowStep: selectNavigation,
        getCurrentWorkflowStepValue: getCurrentNavigationValue,
        resetWorkflow: resetNavigation
    };
}



// WEBPACK FOOTER //
// ./modules/license/services/licenseRegisterNewInstanceWorkflowService.service.js